import styled from 'styled-components'
import { buttonReset } from '~theme'

// eslint-disable-next-line import/prefer-default-export
export const Button = styled.button`
  ${buttonReset};
  color: inherit;
  line-height: 0;
`
